import { render, staticRenderFns } from "./ChangeAdministratorPassword.vue?vue&type=template&id=08e60507&"
import script from "./ChangeAdministratorPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeAdministratorPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports